import Skeleton from "@mui/material/Skeleton";

export const PlayerSkeleton = () => (
  <Skeleton
    variant="rounded"
    sx={{
      position: "relative",
      paddingTop: "56.25%",
      overflow: "hidden",
    }}
  />
);
